import React from 'react';
import { SidebarLayout } from 'modules/shared/layouts';
import { VerticalProductListLoader } from '..';
import { ProductFilterListLoader, ProductSortListLoader } from './components';

export const FilterableProductListLoader: React.FC = React.memo(() => {
    return (
        <SidebarLayout
            sideComponent={<ProductFilterListLoader />}
            contentComponent={<VerticalProductListLoader headerChildren={<ProductSortListLoader />} />}
        />
    );
});
